"use strict";

module.exports = {
  'yellow-100': '#FFDD2D',
  'yellow-200': '#FCC521',
  'yellow-300': '#FAB619',
  'black-100': '#909090',
  'black-200': '#666666',
  'black-300': '#333333',
  'black-400': '#000000',
  'gray-100': '#F5F5F6',
  'gray-200': '#E7E8EA',
  'gray-300': '#CBCFD3',
  'gray-400': '#959BA4',
  'gray-500': '#79818C',
  'gray-600': '#616871',
  'lightBlue-100': '#ECF1F7',
  'lightBlue-200': '#E4EBF3',
  'lightBlue-300': '#DDE4ED',
  'blue-100': '#1771E6',
  'blue-200': '#1464CC',
  'blue-300': '#0953B3',
  'green-100': '#39B54A',
  'green-200': '#2CA53A',
  'green-300': '#168821',
  'red-100': '#E01F19',
  'red-200': '#D3120E',
  'red-300': '#C40B08',
  white: '#FFFFFF'
};